import mutations from './mutations';
import state from './state';
import * as actions from './actions';
import * as getters from './getters';

const module = {
  state: { ...state },
  actions,
  getters,
  mutations,
};

export default { module };



// WEBPACK FOOTER //
// ./src/app/classes/store/index.js